export const categories = [
    {
      name: 'cars',
      image: 'https://wallpaperset.com/w/full/3/5/4/104752.jpg',
    },
    {
      name: 'anime',
      image: 'https://w0.peakpx.com/wallpaper/812/554/HD-wallpaper-jinx-league-of-legends.jpg',
    },
    {
      name: 'wallpaper',
      image: 'https://i.pinimg.com/236x/03/48/b6/0348b65919fcbe1e4f559dc4feb0ee13.jpg',
    },
    {
      name: 'grafitti',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCnacIeBPURCIL04VXWQVNY2Aa1Ja93wHkHL9rZxuJuDhSCWWfafFpZQZw9_KUPrko8qc&usqp=CAU',
    },
    {
      name: 'photography',
      image: 'https://pbblogassets.s3.amazonaws.com/uploads/2019/09/06113039/camera-trends.jpg',
    },
    {
      name: 'architecture',
      image: 'https://parametric-architecture.com/wp-content/uploads/elementor/thumbs/cave_house-2-Gianluigi-Marin-pz24lkbu3z59hffg1h5balfegu8rw7zzwy6lpzv5g8.jpg',
    },
    {
      name: 'cyber punk',
      image: 'https://sportshub.cbsistatic.com/i/2021/08/09/9830b600-fa8f-491a-a3f2-ba868fce7bda/cyberpunk-2077-edit-2-1276334.jpg',
    },
    {
      name: 'painting',
      image: 'https://i.pinimg.com/736x/f4/e5/ba/f4e5ba22311039662dd253be33bf5f0e.jpg',
    }, {
      name: 'gaming',
      image: 'https://content.fortune.com/wp-content/uploads/2016/02/scufgaming3.jpg',
    },
    {
      name: 'cinematic',
      image: 'https://wallup.net/wp-content/uploads/2016/05/26/254484-artwork-digital_art-soldier-futuristic-cyborg-Neo_Japan_2202.jpg',
    }, {
      name: 'pets',
      image: 'https://s3-media0.fl.yelpcdn.com/bphoto/vICZezDCcR-z6TS-BqYLNA/l.jpg',
    }, {
      name: 'dark art',
      image: 'https://wallpapercave.com/wp/wp2920762.jpg',
    },
    {
      name: 'others',
      image: 'https://i.pinimg.com/236x/2e/63/c8/2e63c82dfd49aca8dccf9de3f57e8588.jpg',
    },
  ];
  
  export const feedQuery = `*[_type == "pin"] | order(_createdAt desc) {
    image{
      asset->{
        url
      }
    },
        _id,
        destination,
        postedBy->{
          _id,
          userName,
          image
        },
        save[]{
          _key,
          postedBy->{
            _id,
            userName,
            image
          },
        },
      } `;
  
  export const pinDetailQuery = (pinId) => {
    const query = `*[_type == "pin" && _id == '${pinId}']{
      image{
        asset->{
          url
        }
      },
      _id,
      title, 
      about,
      category,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
     save[]{
        postedBy->{
          _id,
          userName,
          image
        },
      },
      comments[]{
        comment,
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      }
    }`;
    return query;
  };
  
  export const pinDetailMorePinQuery = (pin) => {
    const query = `*[_type == "pin" && category == '${pin.category}' && _id != '${pin._id}' ]{
      image{
        asset->{
          url
        }
      },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
  };
  
  export const searchQuery = (searchTerm) => {
    const query = `*[_type == "pin" && title match '${searchTerm}*' || category match '${searchTerm}*' || about match '${searchTerm}*']{
          image{
            asset->{
              url
            }
          },
              _id,
              destination,
              postedBy->{
                _id,
                userName,
                image
              },
              save[]{
                _key,
                postedBy->{
                  _id,
                  userName,
                  image
                },
              },
            }`;
    return query;
  };
  
  export const userQuery = (userId) => {
    const query = `*[_type == "user" && _id == '${userId}']`;
    return query;
  };
  
  export const userCreatedPinsQuery = (userId) => {
    const query = `*[ _type == 'pin' && userId == '${userId}'] | order(_createdAt desc){
      image{
        asset->{
          url
        }
      },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
  };
  
  export const userSavedPinsQuery = (userId) => {
    const query = `*[_type == 'pin' && '${userId}' in save[].userId ] | order(_createdAt desc) {
      image{
        asset->{
          url
        }
      },
      _id,
      destination,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
  };
  